import { render, staticRenderFns } from "./creat-title.vue?vue&type=template&id=3c94898b&scoped=true"
import script from "./creat-title.vue?vue&type=script&lang=js"
export * from "./creat-title.vue?vue&type=script&lang=js"
import style0 from "./creat-title.vue?vue&type=style&index=0&id=3c94898b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94898b",
  null
  
)

export default component.exports